// extracted by mini-css-extract-plugin
export default {"title":"p_-z","warning":"q_-z","sizeOptionsLegendText":"r_-z"};